import "./styles.scss";
import React from "react";

import Author from "./components/Author";
import Pill from "components/Pill";

import Badge from "components/Badge";
import { usePosts } from "context/posts";

const PostInfo = ({ data }) => {
  const { posts } = usePosts();

  const isLatest = posts?.findIndex((item) => item?.slug === data?.slug) === 0;

  return (
    <div className="container">
      <div className="post-main__info">
        {!!isLatest && (
          <div className="post-main__info__item">
            <Badge label="Najnowszy wpis" variant="red" />
          </div>
        )}

        <div className="post-main__info__item post-main__info__item--author">
          <span className="post-main__info__item__label">Autor:</span>
          <Author
            first_name={data?.author?.node?.firstName}
            last_name={data?.author?.node?.lastName}
            avatar={data?.author?.node?.avatar?.url}
          />
        </div>

        <div className="post-main__info__item post-main__info__item--dates">
          <div className="post-main__info__item__group">
            <span className="post-main__info__item__label">Opublikowano:</span>
            <span className="post-main__info__item__value">{data?.date}</span>
          </div>
          {data?.acfPost?.postUpdateDate && (
            <div className="post-main__info__item__group">
              <span className="post-main__info__item__label">
                Zaktualizowano:
              </span>
              <span className="post-main__info__item__value">
                {data?.acfPost?.postUpdateDate?.replaceAll("/", ".")}
              </span>
            </div>
          )}
        </div>

        <div className="post-main__info__item">
          <span className="post-main__info__item__label">Kategorie:</span>
          <div className="post-main__info__item post-main__info__item__pills">
            {data?.categories?.nodes?.slice(0, 4)?.map((item, index) => (
              <Pill
                key={index}
                label={item?.name}
                href={`/blog/${item?.slug}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostInfo;
